<template>
  <div>
    <div class="fixed-bar" @click="onFilterClick">
      <div data-testid="button-filter" class="fixed-bar__filter">
        <div v-if="filter.hasAnySelection(isFirstRoom)" class="box-dot">
          <span id="dot" data-testid="dot" class="dot"></span>
        </div>
        <i class="icon-filters-rd xs"> </i>
        <p>{{ translate('rdFilters') }}</p>
      </div>
    </div>
    <FilterModal
      ref="filterModal"
      :customer="customer"
      :filter="filter"
      :hotel="hotel"
      :isFirstRoom="isFirstRoom"
      :showBreakfast="showBreakfast"
      @accept="$emit('changeFilter', $event)"
      :selectedRoomCode="selectedRoomCode"
      :numberOfRoomsLeftByRoomId="numberOfRoomsLeftByRoomId"
    >
    </FilterModal>
  </div>
</template>

<script>
import FilterModal from '../modal/FilterModal'
import Filter from '../../domain/Filter'
import Hotel from '../../domain/Hotel'
import Customer from '../../../domain/Customer'

export default {
  name: 'FixedBar',
  components: {
    FilterModal
  },
  props: {
    customer: {
      customer: Customer
    },
    filter: {
      filter: Filter
    },
    hotel: {
      filter: Hotel
    },
    isFirstRoom: {
      type: Boolean,
      defaultValue: false
    },
    showBreakfast: {
      type: Boolean,
      defaultValue: false
    },
    selectedRoomCode: {
      type: String
    },
    numberOfRoomsLeftByRoomId: {
      type: Array
    }
  },
  methods: {
    onFilterClick() {
      showModal(this.$refs.filterModal)
    }
  }
}
const showModal = modalRef => {
  const scrollTop = global.$('html, body').scrollTop() || 0
  const offsetTop = global.$('#main').offset().top || 0

  if (scrollTop < offsetTop - 1) {
    global.$('html, body').animate({ scrollTop: offsetTop }, 500, function () {
      modalRef.open()
    })
  } else {
    modalRef.open()
  }
}
</script>

<style lang="scss" scoped>
.fixed-bar {
  background-color: white;
  border-radius: 50px;
  box-shadow: 0px 0px 23px -4px rgba(0, 0, 0, 0.75);
  position: fixed;
  z-index: 100;
  bottom: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 2.5rem;
  text-align: center;
  width: 85%;
  left: 7%;
  font-weight: bold;
  height: 50px;

  .line-left {
    height: 23px;
  }

  .icon-filters-rd {
    font-size: 2.3rem;
  }
  &__selected {
    font-weight: bold;
  }
  .icon-IDR-rd {
    font-size: 3rem;
    margin-bottom: -5px;
    margin-left: -10px;
  }
  &__filter {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    p {
      margin-bottom: 0;
    }
    .box-dot {
      width: 140%;
      text-align: -webkit-right;
      text-align: -moz-right;
      .dot {
        background-color: #c20808;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: block;
      }
    }
  }
}
</style>
